//whenever you need the current moment use this
//from a top level file so that you can swap it out for tests
//and use a fixed date

module.exports = function getCurrentMoment () {
  return require('moment')();
};

